import styled from 'styled-components';
import { colors, radius } from '../../styles/theme/tokens';

export const HamburgerIcon = styled.button`
  display: grid;
  place-items: center;
  width: 42px;
  height: 42px;
  flex-shrink: 0;
  border-radius: ${radius.pill};
  color: ${colors.ink};
  background: ${colors.surface};
  border: 1.5px solid ${colors.line};
  cursor: pointer;
`;
